module.exports = __webpack_public_path__ + "img/6.ac355ccd.webp";